import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { PlayerProfileField } from 'src/app/models/playerProfileField.model';
import { RecruitMember } from 'src/app/models/recruitMember.modal';
import { RecruitPreferenceOption } from 'src/app/models/recruitPreferenceOption.model';
import { RecruitPreferenceType } from 'src/app/models/recruitPreferenceType.model';
import { RecruitUserPreference } from 'src/app/models/recruitUserPreference.model';
import { environment } from 'src/environments/environment';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class RecruitMemberService {

  constructor(
    private http: HttpClient,
    private settings: AppSettingsService,
  ) { }

  getRecruitMember(): Observable<RecruitMember> {
    const url = this.settings.apiUrl + `appUser/recruitMember`;

    return this.http.get(url).pipe(
      map((data: any) => {
        return new RecruitMember(data);
      })
    );
  }

  getRecruitPreferenceTypes(): Observable<RecruitPreferenceType[]> {
    const url = this.settings.apiUrl + `recruitment/preferenceTypes`;

    return this.http.get(url).pipe(
      map((data: any) => {
        let preferenceTypes: RecruitPreferenceType[] = [];

        data.forEach(preferenceType => {
          preferenceTypes.push(new RecruitPreferenceType(preferenceType));
        });
        return preferenceTypes;
      })
    );
  }

  getRecruitPreferences(): Observable<RecruitPreferenceOption[]> {
    const url = this.settings.apiUrl + `recruitment/preferences`;

    return this.http.get(url).pipe(
      map((data: any) => {
        let preferences: RecruitPreferenceOption[] = [];

        data.forEach(preference => {
          preferences.push(new RecruitPreferenceOption(preference));
        });
        return preferences;
      })
    );
  }

  getRecruitUserPreferences(): Observable<RecruitUserPreference[]> {
    const url = this.settings.apiUrl + `recruitment/preferences/user`;

    return this.http.get(url).pipe(
      map((data: any) => {
        let preferences: RecruitUserPreference[] = [];

        data.forEach(preference => {
          preferences.push(new RecruitUserPreference(preference));
        });
        return preferences;
      })
    );
  }

  updateRecruitUserPreferences(appearInSearch: boolean, preferencesIDs: [number, number][]): Observable<[RecruitUserPreference[], number, PlayerProfileField[]]> {
    let bodyPreferences = preferencesIDs.map(n => {
        return {
            preference_type_id: n[0],
            preference_id: n[1],
            must_have: true
        }
    })
    let body = {
        user_preferences: bodyPreferences,
        appear_in_search: appearInSearch
    }

    const url = this.settings.apiUrl + `recruitment/preferences/user`;

    return this.http.post(url, body).pipe(
      map((data: any) => {
        let dataPreferences = data.recruit_user_preferences;
        let preferences: RecruitUserPreference[] = [];
        let dataMissingFields = data.missing_fields;
        let missingFields: PlayerProfileField[] = [];

        dataMissingFields.forEach(field => {
          missingFields.push(new PlayerProfileField(field));
        });

        dataPreferences.forEach(preference => {
          preferences.push(new RecruitUserPreference(preference));
        });
        return [preferences, data.profile_progress, missingFields];
      })
    );
  }

  deleteRecruitUserPreferences(): Observable<[number, PlayerProfileField[]]> {
    const url = this.settings.apiUrl + `recruitment/preferences/user`;

    return this.http.delete(url).pipe(
      map((data: any) => {
        let dataMissingFields = data.missing_fields;
        let missingFields: PlayerProfileField[] = [];
        let progress = data.profile_progress;

        dataMissingFields.forEach(field => {
          missingFields.push(new PlayerProfileField(field));
        });

        return [progress, missingFields];
      })
    );
  }

  getRecruitPaymentManager(userID: number): Observable<string | null> {
    const url = this.settings.apiUrl + `user/paymentManager/${userID}`;

    return this.http.get(url).pipe(
      map((data: any) => {
        return data.payment_manager;
      })
    )
  }

}
